import $ from 'jquery';
import slick from 'slick-carousel';
import Product from '../layout/components/product';

export default () => {
    (function (ShopColor, $) {
        var $dom = {};
        var arrow = '<svg fill="#000000" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>';
        var cacheDom = function cacheDom() {
            $dom.tabEle = $('.delete_routine');
            $dom.tabPanel = $('.tab-pane');
        };
        var colorCodeSlider = function colorCodeSlider() {
            var $slider = $('#colorSlider');
            $slider.slick({
                slidesToShow: 13,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<span class="slick-arrow slick-prev">' + arrow + '</span>',
                nextArrow: '<span class="slick-arrow slick-next">' + arrow + '</span>',
                infinite: true,
                swipeToSlide: true,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 11,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1
                    }
                }]
            });
        };

        var productSlider = function productSlider() {
            var $pdpslider = $('.filter__products');
            $pdpslider.slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: '<span class="slick-arrow slick-prev">' + arrow + '</span>',
                nextArrow: '<span class="slick-arrow slick-next">' + arrow + '</span>',
                infinite: true,
                swipeToSlide: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }]
            });
        };

        var defaultColor = function defaultColor() {
            var navStyle = '';

            $.ajax({
                url: 'https://brumate-color.herokuapp.com/get_themes?shop_id=1',
                type: 'GET',
                dataType: 'json',
                success: function success(data) {
                    $(data.themes).each(function (index) {
                        if (index == 0) {
                            navStyle += '<li class="selected font-sharp" data-loop-index="' + index + '" data-index="' + data.themes[index].id + '" data-style="' + data.themes[index].name + '">' + data.themes[index].name + '</li>';
                            colorHTMLSwatches(data, index, '');
                            productTabHTML(data, index);
                        } else {
                            navStyle += '<li class="font-sharp" data-loop-index="' + index + '" data-index="' + data.themes[index].id + '" data-style="' + data.themes[index].name + '">' + data.themes[index].name + '</li>';
                        }
                    });

                    $('.nav__style').html(navStyle);
                    $('body').on('click', '.nav__style li', function () {
                        $('.c-loader').addClass('active');
                        $('.nav__style li').removeClass('selected');
                        $(this).addClass('selected');
                        var style = $(this).attr('data-style');
                        colorHTMLSwatches(data, '', style);
                        productTabHTML(data, $(this).attr('data-loop-index'));
                    });
                }
            });
        };
        var colorHTMLSwatches = function colorHTMLSwatches(data, value, style) {
            var colorCode = '';
            if (style == '') {
                $(data.themes[value].colors).each(function (colorIndex, colorKey) {
                    if (colorKey.image_url.url != null) {
                        colorCode += '<div data-id="' + colorKey.id + '" data-themeID="' + colorKey.theme_id + '" data-color="' + colorKey.name + '"><div class="color-swatch"><img src="' + colorKey.image_url.url + '"></div></div>';
                    } else {
                        colorCode += '<div data-id="' + colorKey.id + '" data-themeID="' + colorKey.theme_id + '" data-color="' + colorKey.name + '"><div class="color-swatch"><div style="background-color:' + colorKey.color_code + '"></div></div></div>';
                    }
                });
            } else {
                $(data.themes).each(function (index, value) {
                    if (data.themes[index].name == style) {
                        $(data.themes[index].colors).each(function (colorIndex, colorKey) {
                            if (colorKey.image_url.url != null) {
                                colorCode += '<div data-id="' + colorKey.id + '" data-themeID="' + colorKey.theme_id + '" data-color="' + colorKey.name + '"><div class="color-swatch"><img src="' + colorKey.image_url.url + '"></div></div>';
                            } else {
                                colorCode += '<div data-id="' + colorKey.id + '" data-themeID="' + colorKey.theme_id + '" data-color="' + colorKey.name + '"><div class="color-swatch"><div style="background-color:' + colorKey.color_code + '"></div></div></div>';
                            }
                        });
                    }
                });
            }
            $('#colorSlider').html(colorCode);
            // $('#colorSlider').slick('unslick');
            $('#colorSlider').removeClass('slick-initialized slick-slider');
            colorCodeSlider();
        };
        var productTabHTML = function productTabHTML(data, index) {
            var productContent = '';
            $(data.themes[index].colors).each(function (colorIndex, colorKey) {
                colorKey.products.forEach(function (product) {
                    productContent += Product(product);
                });
                $('.filter__products').html(productContent);
                // $('.filter__products').removeClass('slick-initialized slick-slider');
                // productSlider();
                setTimeout(function () {
                    $('.c-loader').removeClass('active');
                }, 1000);
            });
        };

        var colorSwatchProduct = function colorSwatchProduct() {

            $('body').on('click', '[data-color]', function (e) {
                $('[data-color]').removeClass('selected');
                $('.nav__types li').removeClass('selected');
                $('.nav__types li').eq(0).addClass('selected');
                $('.c-loader').addClass('active');
                $(this).addClass('selected');
                e.preventDefault();
                var theme_id = $(this).attr('data-themeID');
                var colorID = $(this).attr('data-id');
                $('.nav__types').attr('data-themeID', theme_id);
                $('.nav__types').attr('data-id', colorID);
                var data = {
                    theme_id: theme_id,
                    color_id: colorID
                };
                let productHtml = '';
                $.ajax({
                    url: 'https://brumate-color.herokuapp.com/get_products',
                    type: 'GET',
                    data: data,
                    dataType: 'json',
                    success: function success(data) {
                        if (data.products.length == 0) {
                            $('.c-loader').removeClass('active');
                            // $('.filter__products').slick('unslick');
                            $('.filter__products').html('<p class="w-full text-center">Product is not available</p>');
                            return false;
                        } else {
                            data.products.forEach(function (product) {
                                productHtml += Product(product);
                            });
                            $('.filter__products').html(productHtml);
                            // $('.filter__products').removeClass('slick-initialized slick-slider');
                            // productSlider();
                        }
                        $('.c-loader').removeClass('active');
                    }
                });
            });
        };

        var categoriesType = function categoriesType() {
            $('.nav__types li').click(function (e) {
                e.preventDefault();
                $('.nav__types li').removeClass('selected');
                $('.c-loader').addClass('active');
                $(this).addClass('selected');
                var theme_id = $('.nav__types').attr('data-themeID');
                var colorID = $('.nav__types').attr('data-id');
                var filter_tag = $(this).attr('data-type');
                if (filter_tag == 'all') {
                    var _data = {
                        theme_id: theme_id,
                        color_id: colorID
                    };
                    let productHtml = '';
                    $.ajax({
                        url: 'https://brumate-color.herokuapp.com/get_products',
                        type: 'GET',
                        data: _data,
                        dataType: 'json',
                        success: function success(data) {
                            if (data.products.length == 0) {
                                $('.c-loader').removeClass('active');
                                $('.filter__products').html('<p class="w-full text-center">Product is not available</p>');
                                // $('.filter__products').slick('unslick');
                                return false;
                            } else {
                                data.products.forEach(function (product) {
                                    productHtml += Product(product);
                                });
                                $('.filter__products').html(productHtml);
                                // $('.filter__products').removeClass('slick-initialized slick-slider');
                                // productSlider();
                            }
                            $('.c-loader').removeClass('active');
                        }
                    });
                    return false;
                }
                var data = {
                    theme_id: theme_id,
                    color_id: colorID,
                    filter_tag: filter_tag
                };
                let productHtml = '';
                $.ajax({
                    url: 'https://brumate-color.herokuapp.com/get_filter_products',
                    type: 'GET',
                    data: data,
                    dataType: 'json',
                    success: function success(data) {
                        if (data.products.length == 0) {
                            $('.c-loader').removeClass('active');
                            // $('.filter__products').slick('unslick');
                            $('.filter__products').html('<p class="w-full text-center">Product is not available</p>');
                            return false;
                        } else {
                            data.products.forEach(function (product) {
                                productHtml += Product(product);
                            });
                            $('.filter__products').html(productHtml);
                            // $('.filter__products').removeClass('slick-initialized slick-slider');
                            // productSlider();
                        }
                        $('.c-loader').removeClass('active');
                    }
                });
            });
        };

        ShopColor.init = function () {
            cacheDom();
            defaultColor();
            colorSwatchProduct();
            categoriesType();
        };
    })(window.ShopColor = window.ShopColor || {}, $, undefined);
};